import {reactive} from "vue";
import ApontamentoEntidadeEvent from "@/domain/events/apontamentoEntidade.event";

class EmpresaEvents {

    apontamentoEvent = new ApontamentoEntidadeEvent()

    listenerEmpresaGravada = reactive({value: {codigoEmpresa: 0}})

    emitEmpresaGravada(codigoEmpresa: number) {
        this.listenerEmpresaGravada.value = {codigoEmpresa: codigoEmpresa}
    }


}

export default EmpresaEvents;